export enum AppErrorCode {
  Unknown = 0,

  // ── General (1xxx) ────────────────────────────────
  Validation = 1000,
  NotFound = 1001,
  Conflict = 1002,
  Unauthorized = 1003,
  Forbidden = 1004,
  InternalError = 1005,
  TooManyRequests = 1006,
  Gone = 1007,
  BadRequest = 1008,

  // ── Authentication (2xxx) ─────────────────────────
  InvalidCredentials = 2000,
  AccountLocked = 2001,
  EmailNotConfirmed = 2002,
  PhoneNotConfirmed = 2003,
  TokenExpired = 2004,
  InvalidToken = 2005,

  // ── Registration (3xxx) ───────────────────────────
  EmailAlreadyExists = 3000,
  InvalidRegistrationData = 3001,

  // ── Verification (4xxx) ───────────────────────────
  InvalidCode = 4000,
  ExpiredCode = 4001,
  AlreadyVerified = 4002,

  // ── Password reset (5xxx) ─────────────────────────
  EmailNotFound = 5000,
  ResetSessionNotVerified = 5001,
  ResetSessionExpired = 5002,

  // ── Employee (6xxx) ───────────────────────────────
  EmployeeDocumentNotFound = 6000,
  UserLacksEmail = 6001,
  EmployeeLimitReached = 6002,
  EmployeeLimitBelowActiveEmployees = 6003,
  EmployeeLicenseOfferChanged = 6004,
  EmployeeLicenseExpired = 6005,
  ManualInUse = 7001,
  MoveBusinessInvalidPlatform = 9001,
  MoveBusinessNotFound = 9002,
  MoveBusinessInvalidOwner = 9003,
  MoveBusinessPermissionDenied = 9004,
  MoveBusinessChanged = 9005,
  MoveBusinessPreviewExpired = 9006,
  MoveBusinessAlreadyAtDestination = 9007,
  MoveBusinessAuditUnavailable = 9008,
  MoveBusinessUnsupportedTable = 9009,
}
